<template>
  <div class="timelinebox">
    <a-timeline v-if="timelineData.length > 0">
      <a-timeline-item
        :color="index === 0 ? 'blue' : 'gray'"
        v-for="(item, index) in timelineData"
        :key="item.id"
      >
        <div class="timeline-title">
          {{ item.pathLogStatusTypeName }}　{{ item.optTime | formatDate }}
          　　<span v-if="item.score && item.score !== -1">{{ item.score }}分/</span>
          <em :class="{ 'em': item.teacherLinkOpt == 4}">{{ item.teacherLinkOptName }}</em>
          <a-button
            type="primary"
            @click="handleClick"
            v-if="showButton.checkButton && item.linkDetailList && item.linkDetailList.length > 0 && (item.pathLogStatusType === 1 || item.pathLogStatusType === 3) && index === 0"
          >
            去批改
          </a-button>
          <a-button
            type="primary"
            @click="handleCommentClick"
            :data-remark="item.remark"
            v-if="showButton.commentButton && item.remark"
          >
            查看评语
          </a-button>
          <div class="audio-wrap">
            <AudioPlay v-if="item.audioUrl" class="audio-play" :audio-url="item.audioUrl" />
          </div>
          <!-- <AudioPlay class="audio-play" audio-url="https://h-test.aixuexi.com/B:1015:K/1655222400/52e3e201a1e34f74acf2cdede676d701.mp3" /> -->
        </div>
        <div class="imgbox">
          <img
            :src="subItem.path"
            v-for="(subItem, subIndex) in item.linkDetailList"
            :key="subIndex"
            @click="handleImageView(subItem.path)"
          />
        </div>
      </a-timeline-item>
      <viewer :images="images">
        <img v-for="src in images" :key="src" :src="src" />
      </viewer>
    </a-timeline>
    <div
      class="empty"
      v-else
    >
      <a-empty />
    </div>
  </div>
</template>

<script>
// import ViewImg from '@/components/ViewImg/index.vue'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import Vue from 'vue'
import AudioPlay from '@/components/Audio/AudioPlay.vue'

Vue.use(VueViewer)

export default {
  name: 'Timeline',
  components: {
    // ViewImg
    AudioPlay
  },
  props: {
    timelineData: {
      type: Array,
      default: () => []
    },
    showButton: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      viewImgVisible: false
    }
  },
  mounted() {},
  watch: {
    searchParams: {
      handler(nVal, oVal) {
        this.onSearch()
      },
      deep: true
    },
    studentArchiveDrawerVisible(nVal, oVal) {
      if (!nVal) this.updateList()
    }
  },
  filters: {
    formatDate(date) {
      if (!date || date == null) return null
      date = new Date(date)
      let fmt = 'yyyy/MM/dd hh:mm'
      const obj = {
        'y+': date.getFullYear(),
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes()
      }
      for (var k in obj) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 4 ? obj[k] : ('00' + obj[k]).substring(('' + obj[k]).length))
        }
      }
      return fmt
    }
  },
  methods: {
    handleImageView(imgPath) {
      // this.viewImgVisible = true
      this.$viewerApi({
        images: [imgPath]
      })
    },
    handleClick() {
      this.$emit('handleGoCheck')
    },
    handleCommentClick(evt) {
      console.log(evt.target.dataset.remark)
      const h = this.$createElement
      this.$info({
        title: '老师评语',
        content: h('div', { class: 'commentbox' }, `${evt.target.dataset.remark}`),
        onOk() {}
      })
    }
  }
}
</script>
<style lang="less">
.viewer-container {
  .viewer-title,
  .viewer-navbar,
  .viewer-prev,
  .viewer-next {
    display: none;
  }
}
</style>
<style lang="less" scoped>
@import '~@/static/css/base.less';
.timelinebox {
  padding-top: 20px;
}
.ant-timeline {
  :deep(.ant-timeline-item-content) {
    position: relative;
    .timeline-title {
      display: flex;
      align-items: center;
      transform: translateY(-50%);
      padding-top: 20px;
      padding-right: 8px;
      .ant-btn {
        margin-left: 20px;
      }
      .audio-wrap {
        flex: 1;
      }
      .audio-play {
        max-width: 300px;
        width: 100%;
        margin-left: 20px;
      }
      .em {
        color: #ff0000;
      }
    }
  }
  .imgbox {
    margin-top: 10px;
    :deep(img) {
      width: 200px;
      height: 125px;
      margin: 0 20px 20px 0;
    }
  }
}
.commentbox {
  width: 380px;
  height: 120px;
  overflow: auto;
}
.empty {
  margin-top: 20%;
}

</style>